const EMPTY_FORMULA = {
  diceCount: 0,
  diceSides: 0,
  bonus: 0,
};

export function parseDamageFormula(value) {
  if (!value) {
    return { ...EMPTY_FORMULA };
  }

  const match = String(value)
    .trim()
    .match(/^(\d+)\s*d\s*(\d+)(?:\s*([+-])\s*(\d+))?$/i);

  if (!match) {
    return { ...EMPTY_FORMULA };
  }

  const bonusValue = Number(match[4]) || 0;
  return {
    diceCount: Number(match[1]) || 0,
    diceSides: Number(match[2]) || 0,
    bonus: match[3] === "-" ? -bonusValue : bonusValue,
  };
}

export function formatDamageFormula({ diceCount, diceSides, bonus }) {
  const count = Number(diceCount) || 0;
  const sides = Number(diceSides) || 0;
  const constant = Number(bonus) || 0;

  if (count <= 0 || sides <= 0) {
    return "";
  }

  if (constant > 0) {
    return `${count}d${sides}+${constant}`;
  }

  return `${count}d${sides}${constant < 0 ? constant : ""}`;
}
